import React from 'react';
import { NavLink } from 'react-router-dom';

import { NAV_SECTIONS } from '../config/navigation';
import { useAuth } from '../context/AuthContext';
import { NavIcon } from './ui/NavIcon';
import { SITE_INITIALS, SITE_NAME, SITE_TAGLINE } from '../config/branding';

function NavItem({ path, icon, label, onNavigate }) {
  return (
    <NavLink
      to={`/${path}`}
      end={path === 'dashboard'}
      className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
      onClick={onNavigate}
    >
      <NavIcon name={icon} />
      <span className="nav-item-label">{label}</span>
    </NavLink>
  );
}

function NavSection({ title, children }) {
  return (
    <>
      <div className="nav-section">{title}</div>
      {children}
    </>
  );
}

export function Sidebar({ authUsername, onLogout, open = false, onNavigate }) {
  const { canAccessRoute } = useAuth();

  return (
    <aside className={`sidebar${open ? ' sidebar--open' : ''}`} aria-label="Ana menü">
      <NavLink to="/dashboard" className="sidebar-brand" end onClick={onNavigate}>
        <div className="logo-mark" aria-hidden="true">
          {SITE_INITIALS}
        </div>
        <div className="logo-text">
          <div className="logo-title">{SITE_NAME}</div>
          <div className="logo-subtitle">{SITE_TAGLINE}</div>
        </div>
      </NavLink>

      <nav className="sidebar-nav">
        {NAV_SECTIONS.map((section) => {
          const items = section.items.filter((item) => canAccessRoute(item.path));
          if (!items.length) return null;
          return (
            <NavSection key={section.title} title={section.title}>
              {items.map((item) => (
                <NavItem
                  key={item.path}
                  path={item.path}
                  icon={item.icon}
                  label={item.label}
                  onNavigate={onNavigate}
                />
              ))}
            </NavSection>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        {authUsername ? (
          <NavLink to="/hesap" className="sidebar-user" onClick={onNavigate} title="Hesap ayarları">
            <span className="sidebar-user-label">Hesabım</span>
            <span className="sidebar-user-name">{authUsername}</span>
          </NavLink>
        ) : null}
        <button type="button" className="btn btn-ghost btn-block" onClick={onLogout}>
          Çıkış yap
        </button>
      </div>
    </aside>
  );
}
